import 'core-js/stable'
import Vue from 'vue'
import App from './App'
import router from './router'
import CoreuiVue from '@coreui/vue'
import { iconsSet as icons } from './assets/icons/icons.js'
import store from './store'
import VueSwal from 'vue-swal'
import moment from 'moment'

Vue.use(VueSwal);
Vue.use(CoreuiVue);

const VueTouch = require('vue-touch')
Vue.use(VueTouch);

window.axios = require('axios');
window.moment = require('moment')

Vue.config.performance = true
Vue.prototype.$log = console.log.bind(console)

window.APP_MODE = (location.host === "orstyle.online") ? 'production' : 'local' ;

// Add ApiService
window.ApiService = require('./shared/Api');
ApiService = ApiService.ApiService;

window.Fabric = require('./shared/Fabric');
fabric = Fabric.fabric;

new Vue({
  el: '#app',
  router,
  store,
  icons,
  template: '<App/>',
  components: {
    App
  }
})